import React from 'react';
import { CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PopupBase from '../../../../../popup/base/PopupBase';
import CustomButton from '../../../../../components/buttons/CustomButton';
import styles from './Addons.module.css';

/** Confirmação para remover um adicional (mesmo fluxo de antes, só o visual mudou). */
const CancelAddonPopup = ({ isOpen, onClose, onConfirm, isLoading, success, addon }) => {
  if (!isOpen) return null;

  let content;
  let footer;

  if (success === true) {
    content = (
      <div className={styles.popupSuccess}>
        <CheckCircleIcon style={{ fontSize: 56, color: '#16A34A' }} />
        <p className={styles.popupTitle}>Adicional removido</p>
        <p className={styles.popupText}>
          O adicional "{addon?.plan_name}" foi removido. Você ainda terá acesso a ele até o final do período atual.
        </p>
      </div>
    );
    footer = (
      <div className={styles.popupFooter}>
        <CustomButton variant="contained" style="secondary" label="Fechar" onClick={onClose} />
      </div>
    );
  } else if (success === false) {
    content = (
      <p className={styles.popupError}>
        Ocorreu um erro ao remover o adicional. Tente novamente ou fale com o suporte.
      </p>
    );
    footer = (
      <div className={styles.popupFooter}>
        <CustomButton variant="outlined" style="secondary" label="Fechar" onClick={onClose} />
        <CustomButton variant="contained" style="error" label="Tentar novamente" onClick={onConfirm} disabled={isLoading} />
      </div>
    );
  } else {
    content = (
      <div className={styles.popupBody}>
        <p className={styles.popupText}>
          Você está prestes a remover o adicional <strong>{addon?.plan_name}</strong>. Deseja continuar?
        </p>
        <ul className={styles.popupList}>
          <li>Você ainda terá acesso a ele até o final do período atual</li>
          <li>Não haverá renovação automática</li>
          <li>Seu plano principal não será afetado</li>
        </ul>
      </div>
    );
    footer = (
      <div className={styles.popupFooter}>
        <CustomButton variant="outlined" style="primary" label="Voltar" onClick={onClose} />
        <CustomButton
          variant="contained"
          style="secondary"
          label="Confirmar remoção"
          onClick={onConfirm}
          disabled={isLoading}
          icon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
        />
      </div>
    );
  }

  return (
    <PopupBase
      Title={success === true ? 'Adicional removido' : 'Remover adicional'}
      Content={content}
      Footer={footer}
      OnClose={onClose}
    />
  );
};

export default CancelAddonPopup;
